/**
 * Exposes methods that live on the window, that Dixa has added
 */
export const useDixa = () => {
    // Very crude attempt at translating some of their embed script to TS 😓
    const initDixa = (id: string) => {
        (window._dixa =
            window._dixa ||
            function () {
                // eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-non-null-assertion
                (window._dixa!.q = window._dixa?.q || []).push(arguments),
                    // eslint-disable-next-line prefer-rest-params
                    window._dixa?.handler && window._dixa?.handler(arguments);
            }),
            (window._dixa.l = Date.now()),
            (window._dixa.wid = id);
    };

    const setView = (state: 'minimized' | 'conversation') => window._dixa?.('api.setView', state);
    const setLanguage = (language: string) => window._dixa?.('api.setLanguage', language);

    // Yeah, it's super wack, but Dixa won't allow us to set theme, unless we format the object in this way 👀
    const setTheme = (color: string) => window._dixa?.('api.setTheme', `{"color":"${color}"}`);

    const showDixa = () => setView('conversation');
    return { initDixa, showDixa, setLanguage, setTheme };
};
